module.exports = __webpack_public_path__ + "static/media/no@3x.303f4064.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial/no@3x.png
// module id = 752
// module chunks = 0